import { AppState } from '../index'
import { MatchesState } from './reducers'

export * from './actions'
export * from './reducers'
export * from './actionTypes'

export const selectMatchesState = (state: AppState): MatchesState => state.matches
